import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#d4af37] text-[#1a3a52] hover:bg-[#c5a028] hover:shadow-lg focus:ring-[#d4af37]',
    secondary: 'bg-[#1a3a52] text-white hover:bg-[#132c3f] hover:shadow-lg focus:ring-[#1a3a52]',
    outline: 'border-2 border-[#1a3a52] text-[#1a3a52] hover:bg-[#1a3a52] hover:text-white focus:ring-[#1a3a52]',
    ghost: 'text-[#1a3a52] hover:bg-[#1a3a52]/10'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-172">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-173" />}
      {children}
    </button>;
}